/** 网络、接口 相关配置 **/
export const config = {
  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    NO_AUTHORISE: 403,
    REDO_LOGIN: 406,
    ACCESS_CAPTCHA_PERMISSION_429: 429,
    TOO_FREQUENTLY_521: 521,
  },

  restUCompanyGetCompanyInfoPath: "/rest/u/company/getCompanyInfo", // 获取用户信息
  userBehaviorInsertRecordWebsitePath: "/user/behavior/insertRecordWebsite", //公共埋点
  detailAlltypesdetailV2TycGetDataNoLoginPath: "/detail/alltypesdetail/v2/tyc/getDataNoLogin", // 获取企业信息
  userApiMemberSingleFindUserContentPath: "/user/api/member/single/findUserContent", // 1.0获取用户信息
  buryPointUserBehaviorInsertRecordPath: "/burypoint/user/behavior/insertRecord", // 1.0埋点
  apiV1SemGetTargetsByCidsPath:'/api/v1/sem/getTargetsByCids', // 1.0获取gjxx列表三分类

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
    TO_SUBSCRIBE: 500500,
    REQUEST_CANCEL: "REQUEST_CANCEL",
    PERMISSION_EXPIRATION: 310300, // 权限过期
    ACCESS_CAPTCHA_PERMISSION_IS_MISSING: 200622, // 需要滑动验证刷新权限
  },
};
